import { debug } from 'src/logger';
import initialMetricsPublisher from '../metrics';

interface VerifyEmailRequest {
    email: string;
    verificationCode?: string;
}

interface VerifyEmailResponse {
    outcome: string;
}

export const verifyEmail = async (params: VerifyEmailRequest): Promise<VerifyEmailResponse> => {
    try {
        debug('Making VerifyEmail Request:', params);
        const response = await fetch('/getstarted/api/verifyEmail', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(params)
        });
        if (!response.ok) {
            if (response.status === 429) {
                const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('VerifyEmailCall');
                actionMetricsPublisher.publishCounterMonitor('MonsServiceRateLimitCount', 1);
            }
            throw new Error(`Email Verification API request failed with status ${response.status}`);
        }
        const data = await response.json();
        debug('Received VerifyEmail Response:', data);
        return {
            outcome: data.outcome
        };
    } catch (error) {
        console.error('Email verification failed:', error);
        throw error;
    }
};
